import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";

import { ButtonComponent } from "./common/button";
import Error from "../assets/images/error.png";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "5px",
};

const LogoutModal = ({ open, handleLogout, handleClose,title }) => {
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box justifyContent={"end"} textAlign={"end"}>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            className={"d-flex text-center"}
            textAlign={"center"}
            paddingTop={2}
            paddingLeft={8}
            paddingRight={8}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Are you sure?
            </Typography>
          </Box>

          <Box textAlign={"center"}>
            <img
              src={Error}
              alt={"logout-error-icon"}
              className={"logout-error-icon m-2"}
            />
            <Box paddingBottom={3}>
              <ButtonComponent
                variant="contained"
                buttonName={title}
                color={"warning"}
                className={"login-btn common-btn"}
                handleClick={handleLogout}
              />

              <ButtonComponent
                variant="contained"
                buttonName="Cancel"
                color={"error"}
                className={"login-btn ms-2"}
                handleClick={handleClose}
              />
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

LogoutModal.prototype = {
  open: PropTypes.bool,
  handleLogout: PropTypes.func,
  handleClose: PropTypes.func,
  title:PropTypes.string
};
export default LogoutModal;
